import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html'
})
export class AlertMessageComponent implements OnInit {

  success: boolean;
  error: boolean;
  successMessage = "Changes saved successfully.";
  errorMessage = "Failed to save changes.";
  message = "";

  static self: AlertMessageComponent;

  constructor() {
    AlertMessageComponent.self = this;
  }

  ngOnInit() {
  }

  static open(type: AlertType, message: string = "") {
    let self = AlertMessageComponent.self;
    AlertMessageComponent.clearValues();

    if (type == AlertType.Success) {
      self.success = true;
      self.message = message ? message : self.successMessage;
    } else if (type == AlertType.Error) {
      self.error = true;
      self.message = message ? message : self.errorMessage;
    }

    setTimeout(() => {
      AlertMessageComponent.clearValues();
    }, 5000)
  }

  static clearValues() {
    let self = AlertMessageComponent.self;
    self.success = false;
    self.error = false;
  }
}


export class AlertType {
  public static Success = "Success";
  public static Error = "Error";
}



// WEBPACK FOOTER //
// ./src/app/shared/alert-message/alert-message.component.ts